"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcAbstractDropdownBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_input_constants_1 = require("../../atoms/bc-input/bc-input-constants");
var bc_input_select_constants_1 = require("../bc-input-select/bc-input-select-constants");
var bc_input_select_constants_2 = require("../bc-input-select/bc-input-select-constants");
var input_constants_1 = require("../input/input-constants");
var bc_abstract_dropdown_constants_1 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_2 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_3 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_4 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_5 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_6 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_7 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_8 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_9 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_10 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_11 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_12 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_13 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_14 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_15 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_16 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_17 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_18 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_19 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_constants_20 = require("./bc-abstract-dropdown-constants");
var bc_abstract_dropdown_helper_1 = require("./bc-abstract-dropdown-helper");
var bc_card_select_constants_1 = require("../bc-card-select/bc-card-select-constants");
var BcAbstractDropdownBehavior = (function (_super) {
    __extends(BcAbstractDropdownBehavior, _super);
    function BcAbstractDropdownBehavior() {
        var _this = _super.call(this) || this;
        _this.toggleButton = null;
        _this.dropdownContent = null;
        _this.dropdownActive = null;
        _this.dropdownItems = [];
        _this.config = {};
        _this.topMarginContent = 0;
        _this.closeButton = null;
        _this.toggleButtonEventsAdded = false;
        _this.helper = new bc_abstract_dropdown_helper_1.BcDropdownHelper();
        return _this;
    }
    BcAbstractDropdownBehavior.prototype.setConfig = function (config) {
        if (config) {
            this.config = config;
        }
        this.initConfiguration();
    };
    BcAbstractDropdownBehavior.prototype.initConfiguration = function () {
        this.config = {
            toggleClass: this.helper.getProperty(this.config, ['toggleClass'], bc_abstract_dropdown_constants_19._DROPDOWN_TOGGLE_CLASS),
            toggleActiveClass: this.helper.getProperty(this.config, ['toggleActiveClass'], bc_abstract_dropdown_constants_3._DROPDOWN_TOGGLE_ACTIVE_CLASS),
            contentClass: this.helper.getProperty(this.config, ['contentClass'], bc_abstract_dropdown_constants_4._DROPDOWN_CONTENT_CLASS),
            contentActiveClass: this.helper.getProperty(this.config, ['contentActiveClass'], bc_abstract_dropdown_constants_5._DROPDOWN_CONTENT_ACTIVE_CLASS),
            itemClass: this.helper.getProperty(this.config, ['itemClass'], bc_abstract_dropdown_constants_20._DROPDOWN_ITEM_CLASS),
            triangleClass: this.helper.getProperty(this.config, ['triangleClass'], bc_abstract_dropdown_constants_6._DROPDOWN_TRIANGLE_CLASS),
            toggleEvents: this.config.toggleEvents ? this.config.toggleEvents : ['click', 'input'],
            mainClass: this.helper.getProperty(this.config, ['mainClass'], bc_abstract_dropdown_constants_7._DROPDOWN_CLASS),
            mainActiveClass: this.helper.getProperty(this.config, ['mainActiveClass'], bc_abstract_dropdown_constants_8._DROPDOWN_ACTIVE_CLASS),
            static: !this.helper.isNullOrUndefined(this.config.static) ? this.config.static : false,
            isPopUp: !this.helper.isNullOrUndefined(this.config.isPopUp) ? this.config.isPopUp : false,
            isDisabled: !this.helper.isNullOrUndefined(this.config.isDisabled) ? this.config.isDisabled : false,
            parentWidth: !this.helper.isNullOrUndefined(this.config.parentWidth) ? this.config.parentWidth : false,
            contentAutoWidth: !this.helper.isNullOrUndefined(this.config.contentAutoWidth)
                ? this.config.contentAutoWidth
                : false,
            multiple: !this.helper.isNullOrUndefined(this.config.multiple) ? this.config.multiple : false,
            maxHeightContent: !this.helper.isNullOrUndefined(this.config.maxHeightContent)
                ? this.config.maxHeightContent
                : null,
            isAutoStyle: !this.helper.isNullOrUndefined(this.config.isAutoStyle) ? this.config.isAutoStyle : true,
            onlyBottomPosition: !this.helper.isNullOrUndefined(this.config.onlyBottomPosition)
                ? this.config.onlyBottomPosition
                : false,
        };
    };
    BcAbstractDropdownBehavior.prototype.initAccesibilityConfig = function () {
        (0, helpers_1.addFocusable)(this.dropdownContent, {
            expanded: 'true',
            role: 'listbox',
        });
    };
    BcAbstractDropdownBehavior.prototype._setUp = function () {
        var _this = this;
        this.initConfiguration();
        this.getElements();
        if (this.config.isPopUp) {
            this.addDropdownTriangle();
        }
        if (this.config.maxHeightContent) {
            this.configureMaxHeight(this.config.maxHeightContent);
        }
        this.addEventClick();
        if (!this.config.static && !this.mySelf.classList.contains(bc_abstract_dropdown_constants_9._DROPDOWN_UNDIMISS_CLASS)) {
            this.addWindowEventClick();
        }
        window.addEventListener('resize', function () {
            _this.setDropdownContentPosition();
        });
        window.addEventListener('scroll', function (event) {
            if (_this.dropdownContent != event.target) {
                document.querySelector('body')['style'].overflow !== 'hidden' && _this.setDropdownContentPosition();
            }
        }, true);
        this.setAriaExpanded(false);
        this.initAccesibilityConfig();
    };
    BcAbstractDropdownBehavior.prototype.openDrowndown = function () {
        var _this = this;
        this.closeAllDropdowns();
        setTimeout(function () {
            _this.setDropdownContentPosition();
        });
        if (bc_input_select_constants_2.INPUT_SELECT_TOGGLE_CLASS) {
            var input = this.mySelf.querySelector("".concat(bc_input_constants_1.EM_TAG, ".").concat(bc_input_select_constants_2.INPUT_SELECT_TOGGLE_CLASS));
            if (input) {
                input.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_UP;
            }
            var inputMySelf = this.mySelf.querySelector("".concat(bc_input_constants_1.EM_TAG, ".").concat(bc_input_select_constants_2.INPUT_SELECT_ACTIVE_TOGGLE_CLASS));
            if (inputMySelf) {
                inputMySelf.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_UP;
            }
        }
        var dropdownContent = this.dropdownContent;
        this.setAriaExpanded(true);
        (0, helpers_1.replaceClass)(dropdownContent, this.config.contentClass, this.config.contentActiveClass);
        (0, helpers_1.replaceClass)(this.toggleButton, this.config.toggleClass, this.config.toggleActiveClass);
        (0, helpers_1.replaceClass)(this.mySelf, this.config.mainClass, this.config.mainActiveClass);
        this.dropdownActive = dropdownContent;
        if (this.dropdownContent) {
            window.dispatchEvent(new CustomEvent(bc_abstract_dropdown_constants_18._DROPDOWN_OPENED_EVENT, { detail: this.dropdownContent.getAttribute('id') }));
        }
        if (this.config.parentWidth) {
            this.setParentWidth();
        }
    };
    BcAbstractDropdownBehavior.prototype.closeDropdown = function (discard) {
        if (bc_input_select_constants_2.INPUT_SELECT_ACTIVE_TOGGLE_CLASS) {
            var input = this.mySelf.querySelector("".concat(bc_input_constants_1.EM_TAG, ".").concat(bc_input_select_constants_2.INPUT_SELECT_ACTIVE_TOGGLE_CLASS));
            var inputArrow = this.mySelf.querySelector("".concat(bc_input_constants_1.EM_TAG, ".").concat(bc_input_select_constants_2.INPUT_SELECT_TOGGLE_CLASS));
            if (input) {
                input.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
            }
            if (inputArrow) {
                inputArrow.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
            }
        }
        (0, helpers_1.replaceClass)(this.dropdownContent, this.config.contentActiveClass, this.config.contentClass);
        (0, helpers_1.replaceClass)(this.toggleButton, this.config.toggleActiveClass, this.config.toggleClass);
        (0, helpers_1.replaceClass)(this.mySelf, this.config.mainActiveClass, this.config.mainClass);
        this.dropdownActive = null;
        this.setAriaExpanded(false);
        if (this.toggleButton) {
            this.toggleButton.classList.remove(bc_abstract_dropdown_constants_10._DROPDOWN_DROPTOP_CLASS);
        }
        if (this.dropdownContent !== null && !discard) {
            window.dispatchEvent(new CustomEvent(bc_abstract_dropdown_constants_1._DROPDOWN_CLOSED_EVENT, { detail: this.dropdownContent.getAttribute('id') }));
        }
        if (discard) {
            window.dispatchEvent(new CustomEvent(bc_abstract_dropdown_constants_2._DROPDOWN_DISCARDED_EVENT, { detail: this.dropdownContent.getAttribute('id') }));
        }
    };
    BcAbstractDropdownBehavior.prototype.setAriaExpanded = function (expanded) {
        var _a;
        (_a = this.dropdownContent) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', String(expanded));
    };
    BcAbstractDropdownBehavior.prototype.setHeightContent = function (positionContent) {
        this.targetOffsetPos = this.mySelf.getBoundingClientRect();
        this.dropdownOffsetPos = this.dropdownContent.getBoundingClientRect();
        var top = this.targetOffsetPos.top + this.targetOffsetPos.height;
        this.windowHeight = document.documentElement.clientHeight;
        this.bodyHeight = document.body.offsetHeight;
        if (positionContent === 'bottom') {
            if (top + this.dropdownOffsetPos.height > this.windowHeight &&
                this.targetOffsetPos.top > this.dropdownOffsetPos.height) {
                this.configureMaxHeight(this.firstHeight);
                return;
            }
            if (top + this.dropdownOffsetPos.height > this.windowHeight &&
                this.targetOffsetPos.top < this.dropdownOffsetPos.height &&
                this.bodyHeight > this.windowHeight) {
                if (top + this.dropdownOffsetPos.height > this.bodyHeight) {
                    var lessHeight = top + this.dropdownOffsetPos.height - this.windowHeight;
                    var maxHeight = this.firstHeight - lessHeight;
                    this.configureMaxHeight(maxHeight);
                    return lessHeight;
                }
                else {
                    this.configureMaxHeight(this.firstHeight);
                    return;
                }
            }
            if (top + this.dropdownOffsetPos.height > this.windowHeight &&
                this.targetOffsetPos.top < this.dropdownOffsetPos.height &&
                this.bodyHeight < this.windowHeight) {
                var lessHeight = top + this.dropdownOffsetPos.height - this.windowHeight;
                var maxHeight = this.firstHeight - lessHeight;
                this.configureMaxHeight(maxHeight);
                return lessHeight;
            }
            this.configureMaxHeight(this.firstHeight);
            return false;
        }
    };
    BcAbstractDropdownBehavior.prototype.addEventClick = function () {
        var _this = this;
        var eventToggle = function (event, discard) {
            _this.clickToggleEvent(event, discard);
        };
        if (this.toggleButton && !this.toggleButtonEventsAdded) {
            this.config.toggleEvents.forEach(function (event) {
                _this.toggleButton.removeEventListener(event, eventToggle);
                _this.toggleButton.addEventListener(event, eventToggle);
            });
            this.toggleButtonEventsAdded = true;
        }
        this.configureExtraToggles(this.clickToggleEvent);
        (0, helpers_1.addFocusable)(this.toggleButton, { haspopup: 'listbox' }, { event: this.clickToggleEvent.bind(this) });
        if (this.closeButton !== null) {
            this.closeButton.addEventListener('click', function (event) {
                eventToggle(event, true);
            });
            (0, helpers_1.addFocusable)(this.closeButton, { haspopup: 'listbox' }, { event: eventToggle });
        }
    };
    BcAbstractDropdownBehavior.prototype.clickToggleEvent = function (event, discard) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (this && this.disabled) {
            return;
        }
        this.toggleDropdown(discard);
        this.emitEvent(event);
    };
    BcAbstractDropdownBehavior.prototype.emitEvent = function (event) {
        return event;
    };
    BcAbstractDropdownBehavior.prototype.toggleDropdown = function (discard, noClose) {
        if (!this.validateDropdownIsActive()) {
            this.dropdownActive = null;
        }
        if (this.dropdownActive != null && !noClose) {
            this.closeDropdown(discard);
        }
        else {
            this.openDrowndown();
        }
    };
    BcAbstractDropdownBehavior.prototype.configureExtraToggles = function (clickEvent) {
        var _this = this;
        if (this.config.extraToggles) {
            for (var _i = 0, _a = this.config.extraToggles; _i < _a.length; _i++) {
                var extraToggle = _a[_i];
                var element = void 0;
                if (extraToggle.id) {
                    element = this.mySelf.querySelector("*[id='".concat(extraToggle.id, "']"));
                }
                else {
                    element = extraToggle.node;
                }
                if (element) {
                    for (var _b = 0, _c = extraToggle.events; _b < _c.length; _b++) {
                        var event_1 = _c[_b];
                        element.addEventListener(event_1, function (data) {
                            clickEvent.bind(_this, data);
                        });
                    }
                }
            }
        }
    };
    BcAbstractDropdownBehavior.prototype.getElements = function () {
        this.toggleButton = this.mySelf.querySelector(".".concat(this.config.toggleActiveClass, ",.").concat(this.config.toggleClass));
        if (!this.toggleButton &&
            (this.mySelf.classList.contains(this.config.toggleActiveClass) ||
                this.mySelf.classList.contains(this.config.toggleClass))) {
            this.toggleButton = this.mySelf;
        }
        if (this.toggleButton) {
            this.idContent = this.toggleButton.getAttribute('aria-controls');
        }
        this.dropdownContent = this.mySelf.querySelector("*[id='".concat(this.idContent, "']"));
        if (this.dropdownContent !== null) {
            this.dropdownItems = Array.from(this.dropdownContent.querySelectorAll("*[class~='".concat(this.config.itemClass, "']")));
            this.closeButton = this.dropdownContent.querySelector("*[class~='".concat(bc_abstract_dropdown_constants_16._DROPDOWN_CLOSE_BUTTON_CLASS, "']"));
        }
    };
    BcAbstractDropdownBehavior.prototype.validateDropdownIsActive = function () {
        return this.dropdownContent !== null
            ? this.dropdownContent.classList.contains(this.config.contentActiveClass)
            : false;
    };
    BcAbstractDropdownBehavior.prototype.setDropdownContentPosition = function () {
        var _a;
        if (this.dropdownActive !== null && this.config.isAutoStyle) {
            this.validateFirstHeight();
            this.targetOffsetPos = this.mySelf.getBoundingClientRect();
            this.dropdownOffsetPos = this.dropdownContent.getBoundingClientRect();
            this.windowWidth = document.documentElement.clientWidth;
            this.windowHeight = document.documentElement.clientHeight;
            this.triangle && this.triangle.classList.remove(bc_abstract_dropdown_constants_10._DROPDOWN_DROPTOP_CLASS);
            var right = bc_abstract_dropdown_constants_12._DROPDOWN_NUMBER_0;
            var bottom = bc_abstract_dropdown_constants_12._DROPDOWN_NUMBER_0;
            var left = this.targetOffsetPos.left;
            var top_1 = this.targetOffsetPos.top + this.targetOffsetPos.height;
            (_a = this.position(top_1, left, right, bottom), top_1 = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom);
            this.setPosition(left, right, top_1, bottom);
        }
    };
    BcAbstractDropdownBehavior.prototype.position = function (top, left, right, bottom) {
        if (!this.config.onlyBottomPosition) {
            if (this.config.isPopUp) {
                top = top + bc_abstract_dropdown_constants_13._DROPDOWN_NUMBER_11;
            }
            if (left + this.dropdownOffsetPos.width >= this.windowWidth) {
                right = this.windowWidth - (left + this.targetOffsetPos.width);
                left = bc_abstract_dropdown_constants_11._DROPDOWN_NUMBER_1;
            }
            if (top + this.dropdownOffsetPos.height > this.windowHeight &&
                this.dropdownOffsetPos.height + this.targetOffsetPos.height > top) {
                bottom =
                    this.windowHeight -
                        (this.targetOffsetPos.y + this.targetOffsetPos.height + this.dropdownOffsetPos.height - bc_abstract_dropdown_constants_15._DROPDOWN_NUMBER_26);
                top = bc_abstract_dropdown_constants_11._DROPDOWN_NUMBER_1;
            }
            else if (top + this.dropdownOffsetPos.height >= this.windowHeight) {
                bottom = this.windowHeight - (this.targetOffsetPos.bottom - this.targetOffsetPos.height - bc_abstract_dropdown_constants_14._DROPDOWN_NUMBER_14);
                top = bc_abstract_dropdown_constants_11._DROPDOWN_NUMBER_1;
                this.triangle && this.triangle.classList.add(bc_abstract_dropdown_constants_10._DROPDOWN_DROPTOP_CLASS);
            }
        }
        else {
            left = bc_abstract_dropdown_constants_12._DROPDOWN_NUMBER_0;
            right = bc_abstract_dropdown_constants_12._DROPDOWN_NUMBER_0;
            top = bc_abstract_dropdown_constants_12._DROPDOWN_NUMBER_0;
            bottom = bc_abstract_dropdown_constants_1._DROPDOWN_NUMBER_60;
        }
        return { top: top, left: left, right: right, bottom: bottom };
    };
    BcAbstractDropdownBehavior.prototype.validateFirstHeight = function () {
        if (!this.firstHeight) {
            this.firstHeight = this.dropdownContent.clientHeight;
        }
        else {
            this.configureMaxHeight(this.firstHeight);
        }
    };
    BcAbstractDropdownBehavior.prototype.setPosition = function (left, right, top, bottom) {
        if (!this.config.onlyBottomPosition) {
            if (left !== bc_abstract_dropdown_constants_11._DROPDOWN_NUMBER_1) {
                this.dropdownContent['style'].left = "".concat(left, "px");
                this.dropdownContent['style'].right = 'auto';
            }
            else {
                this.dropdownContent['style'].left = 'auto';
                this.dropdownContent['style'].right = "".concat(right, "px");
            }
            if (top !== bc_abstract_dropdown_constants_11._DROPDOWN_NUMBER_1) {
                this.dropdownContent['style'].top = "".concat(top, "px");
                this.dropdownContent['style'].bottom = 'auto';
                this.setHeightContent();
            }
            else {
                var conditionBotton = this.setHeightContent('bottom');
                if (conditionBotton) {
                    this.dropdownContent['style'].top = 'auto';
                    this.dropdownContent['style'].bottom = "".concat(bottom + conditionBotton, "px");
                }
                else {
                    this.dropdownContent['style'].top = 'auto';
                    this.dropdownContent['style'].bottom = "".concat(bottom, "px");
                }
            }
        }
        else {
            this.dropdownContent['style'].position = 'absolute';
            this.dropdownContent['style'].top = 'calc(100% - 5px)';
        }
    };
    BcAbstractDropdownBehavior.prototype.addDropdownTriangle = function () {
        this.triangle = document.createElement('div');
        this.triangle.classList.add(this.config.triangleClass);
        this.mySelf.appendChild(this.triangle);
    };
    BcAbstractDropdownBehavior.prototype.configureMaxHeight = function (height) {
        this.dropdownContent.style.maxHeight = height - bc_abstract_dropdown_constants_11._DROPDOWN_NUMBER_1 + 'px';
        if (this.dropdownContent['classList'].contains(bc_card_select_constants_1.CARD_SELECT_DROPDOWN_ACTIVE_CLASS)) {
            this.dropdownContent.style.maxHeight = 'fit-content';
        }
    };
    BcAbstractDropdownBehavior.prototype.addWindowEventClick = function () {
        var _this = this;
        window.addEventListener('click', function (event) {
            event.stopPropagation();
            var isToggleElement = event.target['className'].indexOf(_this.config.toggleClass) !== -1;
            var isInputElement = event.target['className'].indexOf(input_constants_1.INPUT) !== -1;
            var isMainElement = _this.config.multiple
                ? event.target['className'].indexOf(_this.config.itemClass) !== -1
                : false;
            if (_this.dropdownActive && !isToggleElement && (!isMainElement || !isInputElement)) {
                _this.closeDropdown();
            }
        });
    };
    BcAbstractDropdownBehavior.prototype.setParentWidth = function () {
        if (!this.config.contentAutoWidth) {
            var parentWidth = this.mySelf.clientWidth;
            if (parentWidth >= bc_abstract_dropdown_constants_17._DROPDOWN_NUMBER_243) {
                this.dropdownContent.style.width = "".concat(parentWidth, "px");
            }
            else {
                this.dropdownContent.style.width = "".concat(bc_abstract_dropdown_constants_17._DROPDOWN_NUMBER_243, "px");
            }
        }
    };
    BcAbstractDropdownBehavior.prototype.closeAllDropdowns = function () {
        document.querySelectorAll('.' + bc_input_select_constants_1.INPUT_SELECT_ACTIVE_CLASS).forEach(function (dropdown) {
            (0, helpers_1.replaceClass)(dropdown, bc_input_select_constants_1.INPUT_SELECT_ACTIVE_CLASS, bc_input_select_constants_2.INPUT_SELECT_CLASS);
        });
        document.querySelectorAll('.' + bc_input_select_constants_1.INPUT_SELECT_ACTIVE_CONTENT_CLASS).forEach(function (dropdown) {
            (0, helpers_1.replaceClass)(dropdown, bc_input_select_constants_1.INPUT_SELECT_ACTIVE_CONTENT_CLASS, bc_input_select_constants_2.INPUT_SELECT_CONTENT_CLASS);
        });
    };
    return BcAbstractDropdownBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcAbstractDropdownBehavior = BcAbstractDropdownBehavior;
